import styles from './FilterWrapper.module.scss';
import Icon from '../../Icon/Icon';
import type { FilterWrapperProps } from './interface';

const FilterWrapper = ({
  selectedItemCount,
  onFilterClick,
  children,
}: FilterWrapperProps) => {
  const filterText = selectedItemCount
    ? `${selectedItemCount} Filter angewendet`
    : 'Filtern';
  return (
    <div className={styles.base}>
      <div className={styles.filter}>{children}</div>
      <div className={styles.filterButton} onClick={onFilterClick}>
        <Icon
          variant={'user/item-list'}
          size="iconSize24"
          className={styles.icon}
        />
        <span className={styles.text}>{filterText}</span>
      </div>
    </div>
  );
};

export default FilterWrapper;
